<template>
  <div class="home">
    <h1 class="my-4 text-h5 font-weight-bold text-center">
      請提供您的健康行為及目前健康狀況<br />以供我們確認您今年應做的健康檢查項目
    </h1>
    <div class="mt-4">
      <QuestionContent
        :person.sync="person"
        :valid.sync="valid"
        :目前狀態.sync="目前狀態"
      ></QuestionContent>
    </div>

    <v-row justify="center">
      <v-col class="col-auto">
        <v-btn
          @click="$router.push('/quick')"
          class="mt-12 px-12 mx-2"
          x-large
          color="primary"
        >
          上一頁
        </v-btn>
        <v-btn @click="save" class="mt-12 px-12 mx-2" x-large color="primary"
          >確認送出</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import QuestionContent from "@/components/QuestionContent/ItemCheck";
import util from "@/mixins/util";
export default {
  name: "ItemCheck",
  components: { QuestionContent },
  mixins: [util],
  data: () => ({
    valid: false,
    person: null,
    目前狀態: null,
  }),
  async created() {
    this.person = { ...this.$store.state.person };
    this.目前狀態 = this.person.目前狀態 || {
      我目前有嚼食檳榔的習慣: false,
      我過去曾經有嚼食檳榔的習慣: false,
      我目前有吸菸的習慣: false,
      我過去曾經有吸菸的習慣: false,
      我有大腸癌病史: false,
      我有大腸癌家族史: false,
      我有肺癌家族史: false,
      我曾經有過性行為: false,
      我目前懷孕中: false,
      我有乳癌病史或乳癌家族史: false,
    };
  },
  methods: {
    save: async function () {
      let person = { ...this.person };
      if (this.age < 30) {
        if (
          this.性別 == "男" &&
          this.目前狀態.我目前有嚼食檳榔的習慣 == false &&
          this.目前狀態.我過去曾經有嚼食檳榔的習慣 == false &&
          this.目前狀態.我目前有吸菸的習慣 == false
        ) {
          this.$toast.error(
            "您今年尚無可接受之預防保健服務，但如有身體不適，請直接前往醫療院所諮詢或接受進一步檢查喔！"
          );
          this.$router.push("/quick");
        }
        if (
          this.性別 == "女" &&
          this.目前狀態.我目前有嚼食檳榔的習慣 == false &&
          this.目前狀態.我過去曾經有嚼食檳榔的習慣 == false &&
          this.目前狀態.我目前有吸菸的習慣 == false &&
          this.目前狀態.我曾經有過性行為 == false
        ) {
          this.$toast.error(
            "您今年尚無可接受之預防保健服務，但如有身體不適，請直接前往醫療院所諮詢或接受進一步檢查喔！"
          );
          this.$router.push("/quick");
        }
      }
      person.目前狀態 = { ...this.目前狀態 };
      let 篩檢項目 = (await this.axios.post("/pre-check", this.目前狀態)).data
        .篩檢項目;
      person.可篩檢項目 = 篩檢項目;
      if (_.find(篩檢項目, (v) => v)) {
        this.$store.commit("setState", { person });
        this.$router.push("/quick/itemConfirm");
      } else {
        this.$toast.error("抱歉，今年沒有符合的篩檢項目！");
        this.$router.push("/quick");
      }
    },
  },
};
</script>
